import { UsersStateX } from '../../types/mfc'
import { restoreQuickReply } from '../actions/message'
import { UserEvent } from '../constants/enums'
import { restoreRooms, setupInteractionIntervals } from '../mfcLogic/rooms'
import { pubSub } from './pubSub'
import { appState } from './state.app'

const initialUsersState: UsersStateX = {
    modelsRequested: false,
    modelsLoaded: false,
}

const setUsersState = appState('USERS', initialUsersState)

export const getUsersState = () => appState().USERS

const setUsersModelsLoadedState = (modelsLoaded) => {
    setUsersState({
        modifications: {
            modelsLoaded,
        },
        immediately: true,
    })
}

const setUsersModelsRequestedState = (modelsRequested) => {
    setUsersState({
        modifications: {
            modelsRequested,
        },
        immediately: true,
    })
}

const waitForInitialModelListClosure = (
    state: {
        resolve: null | ((loaded) => void)
        promise: null | Promise<UserEvent>
    } = {
        resolve: null,
        promise: null,
    },
) => {
    pubSub.USERS.on(UserEvent.MODELS_LOADED, () => {
        if (!state.promise) {
            return
        }

        state.promise = null
        state.resolve(true)
        state.resolve = null
    })

    return async () => {
        const { modelsLoaded } = getUsersState()

        if (modelsLoaded) {
            return modelsLoaded
        }

        if (!state.promise) {
            state.promise = new Promise<UserEvent>(
                (resolve) => (state.resolve = resolve),
            )
        }

        return state.promise
    }
}

export const waitForInitialModelList = waitForInitialModelListClosure()

pubSub.USERS.on(UserEvent.MODELS_REQUESTED, () => {
    setUsersModelsRequestedState(true)
})

pubSub.USERS.on(UserEvent.MODELS_LOADED, () => {
    setUsersModelsLoadedState(true)
    setupInteractionIntervals()
    // restoreSessions()
    restoreQuickReply()
    restoreRooms()
})
